<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="btn-row" v-if="checkActionPerm('update_discount') && servcOrder.workAssignStateX == allWorkAssignStateX && !servcOrder.servcAmountFixed && !userIsShopFlag">
            <div class="fr">
                <div class="swb-btn swb-btn-small" v-if="!showUpdateDiscount && !servcOrder.cancelled" @click="showUpdateDiscount = true">改价</div>
                <div class="swb-btn swb-btn-small" v-if="showUpdateDiscount" @click="saveChangePrice">保存改价</div>
                <div class="swb-btn swb-btn-small" v-if="showUpdateDiscount" @click="cancelPrice">取消改价</div>
            </div>
        </div>
        <div class="order-detail-panel">
            <div class="trade-status">
                <table class="trade-status-table">
                    <tbody>
                    <tr>
                        <td class="trade-imfor table-td">
                            <div class="info-block">
                                <ul class="pb15">
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">订单编号</div>
                                        <div class="trade-imfor-dd">{{servcOrder.no}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">买家</div>
                                        <div class="trade-imfor-dd">{{servcOrder.buyerName}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">买家业务单元</div>
                                        <div class="trade-imfor-dd">{{servcOrder.buyerShopName}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">买家业务部门</div>
                                        <div class="trade-imfor-dd">{{servcOrder.buyerBizUnitName}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">服务预约时间</div>
                                        <div class="trade-imfor-dd">{{servcOrder.planTime}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">收货地址</div>
                                        <div class="trade-imfor-dd">
                                            <span>{{servcOrder.buyerShopAddr}}，{{servcOrder.buyerShopContactTel}}</span>
                                        </div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">故障描述</div>
                                        <div class="trade-imfor-dd">{{servcOrder.troubleDesc}}</div>
                                    </li>
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">买家留言</div>
                                        <div class="trade-imfor-dd">{{servcOrder.postscript}}</div>
                                    </li>
                                </ul>
                            </div>
                        </td>
                        <td class="trade-detail table-td">
                            <div class="info-block">
                                <ul class="pb15">
                                    <li class="table-list">
                                        <div class="trade-imfor-dt">订单状态:</div>
                                        <div class="trade-imfor-dd" style="width: auto;">
                                            <span>{{servcOrder.state}}</span>
                                        </div>
                                        <div v-if="servcOrder.cancelled">
                                            <div class="trade-imfor-dt">取消原因:</div>
                                            <div class="trade-imfor-dd" style="width: auto;">
                                                <span>{{servcOrder.cancelCause}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="orders-list-container mt20">
            <table class="orders-list-panel1">
                <colgroup>
                    <col width="300px">
                    <col width="135px">
                    <col width="135px">
                    <col width="135px">
                    <col width="135px">
                    <col width="135px">
                    <col width="135px">
                    <col width="135px">
                    <col width="160px">
                    <col width="160px">
                    <col width="200px">
                </colgroup>
                <thead class="orders-header">
                <tr class="">
                    <th>服务</th>
                    <th>上门费</th>
                    <th>服务费</th>
                    <th>配件费</th>
                    <th>响应时长(分钟)</th>
                    <th>到达时长(分钟)</th>
                    <th>完成时长(分钟)</th>
                    <th>优惠金额(元)</th>
                    <th>协议价(元)</th>
                    <th>结算价(元)</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody class="orders-body" v-for="servcOrderItem in servcOrder.itemList">
                <tr class="blank-row">
                    <td colspan="8"></td>
                </tr>
                <tr class="info-row">
                    <td>
                        <div class="goods-info-block">
                            <div class="goods-item clearfix">
                                <div class="good-img">
                                    <img :src="servcOrderItem.servcFileBrowseUrl"/>
                                </div>
                                <div class="good-msg">
                                    <p class="ellipsis-2 font12">{{servcOrderItem.title}}</p>
                                </div>
                            </div>
                            <div class="clr"></div>
                        </div>
                    </td>
                    <td>
                        <div class="align-right" v-if="!userIsShopFlag">
                            ¥<b class="price">{{parseFloat(servcOrderItem.toDoorFee).toFixed(2)}}</b>
                        </div>
                    </td>
                    <td>
                        <div class="align-right" v-if="!userIsShopFlag &&servcOrderItem.generallFee != null">
                            <span>¥<b class="price">{{parseFloat(servcOrderItem.generallFee).toFixed(2)}}</b></span>
                        </div>
                        <div class="align-right" v-else-if="!userIsShopFlag">¥<b class="price">0.00</b></div>
                    </td>
                    <td>
                        <div class="align-right" v-if="!userIsShopFlag &&servcOrderItem.accFee != null">
                            <span>¥<b class="price">{{parseFloat(servcOrderItem.accFee).toFixed(2)}}</b></span>
                        </div>
                        <div class="align-right" v-else-if="!userIsShopFlag">¥<b class="price">0.00</b></div>
                    </td>
                    <td class="align-right">
                        <b class="pri">{{servcOrderItem.yqRspTimeMi || 0}}</b>
                    </td>
                    <td class="align-right">
                        <b class="pri">{{servcOrderItem.yqArriveTimeMi || 0}}</b>
                    </td>
                    <td class="align-right">
                        <b class="pri">{{servcOrderItem.yqRepairedTimeMi || 0}}</b>
                    </td>
                    <td>
                        <div v-if="!userIsShopFlag">
                            <div class="align-right" v-if="servcOrderItem.discount != null && !showUpdateDiscount">
                                <span>¥<b class="price">{{parseFloat(servcOrderItem.discount || 0.00).toFixed(2)}}</b></span>
                            </div>
                            <div v-if="showUpdateDiscount">
                                <span>¥<b class="price align-right"><el-input style="width: 100px;" type="number" v-model="servcOrderItem.discount" :controls="false" @blur="changeExtraDistCount(servcOrderItem.id)" :min="0" :max="servcOrderItem.totalDiscount"/></b></span>
                            </div>
                            <!--<div class="swb-btn-link" :title="servcOrderItem.feeDesc">价格说明</div>-->
                            <!--价格说明-->

                            <div class="introduce-box fr">
                                <div class="caption">价格说明</div>
                                <div class="content">{{servcOrderItem.feeDesc}}</div>
                            </div>
                        </div>

                    </td>
                    <td>
                        <div class="align-right" v-if="!userIsShopFlag" style="width: inherit">
                            <span>¥<b class="price">{{(parseInt(servcOrderItem.toDoorFee || 0) + parseInt(servcOrderItem.workFee || 0) + parseInt(servcOrderItem.accFee || 0) + parseInt(servcOrderItem.generallFee || 0)).toFixed(2)}}</b></span>
                        </div>
                        <div class="" v-else-if="!userIsShopFlag">¥<b class="price">0.00</b></div>
                    </td>
                    <td class="align-right">
                        <span class="" v-if="!userIsShopFlag">¥<b class="price">{{parseFloat(servcOrderItem.amount).toFixed(2)}}</b></span>
                    </td>
                    <td>
                        <a class="font14 swb-btn-link" v-if="checkActionPerm('apply_after_sale') && servcOrder.svcNo == null && servcOrderItem.finished && servcOrderItem.wrntDueTime != null && servcOrderItem.wrntDueTime.format('yyyy-MM-dd') >= curDate.format('yyyy-MM-dd')" @click="doSaleServc(servcOrderItem.orderId,servcOrderItem.id)">申请售后</a>
                        <a class="font14 swb-btn-link" v-if="checkActionPerm('create_order_by_proxy') && servcOrder.svcNo == null && servcOrderItem.finished && servcOrderItem.wrntDueTime != null && servcOrderItem.wrntDueTime.format('yyyy-MM-dd') < curDate.format('yyyy-MM-dd')" @click="agencyOrder(servcOrderItem.orderId,servcOrderItem.ssuId)">代理下单</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="order-amount mt10">
            <div class="total-amount-panel">
                <table class="">
                    <tbody>
                    <tr v-if="!userIsShopFlag ">
                        <td class="total-count">
                            <div class="total-count-wrapper">
                                <div class="total-count-line">
                                    <span class="label" style="margin-right: 10px">协议价：</span>
                                    <div class="inline-block align-left" style="width: 120px">
                                        <span class="font14 font-bold font-black" v-if="servcOrder.totalAmount != null">¥ {{(servcOrder.totalAmount).toFixed(2)}}</span>
                                        <span class="font14 font-bold font-black" v-else>¥ 0.00</span>
                                    </div>
                                </div>
                                <div class="total-count-line">
                                    <span class="label" style="margin-right: 10px">总优惠：</span>
                                    <div class="inline-block align-left" style="width: 120px">
                                        <span class="font14 font-bold font-black" v-if="servcOrder.totalDiscount != null">¥ {{(servcOrder.totalDiscount).toFixed(2)}}</span>
                                        <span class="font14 font-bold font-black" v-else>¥ 0.00</span>
                                    </div>
                                </div>
                                <div class="total-count-line">
                                    <span class="label" style="margin-right: 10px">结算价：</span>
                                    <div class="inline-block align-left" style="width: 120px">
                                        <span class="font14 font-bold font-black" v-if="servcOrder.amount != null">¥ {{(servcOrder.amount).toFixed(2)}}</span>
                                        <span class="font14 font-bold font-black" v-else>¥ 0.00</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'

    import servcOrderApi from '../../api/servcOrder'
    import userApi from '../../api/user'
    import SwbServcWorkVoucherOfOrder from '../workVoucher/ServcWorkVoucherOfOrder';
    Vue.regist(SwbServcWorkVoucherOfOrder);

    import SwbAfterSaleOrderCreate from './AfterSaleOrderCreate';
    Routes.add(SwbAfterSaleOrderCreate);

    import SwbServcOrderCreate from './ServcOrderCreate';
    Routes.add(SwbServcOrderCreate);

    export default {
        name: 'swb-servc-order-details',
        desc: '',
        props: ['orderId', 'selfPath'],
        data: function () {
            return {
                servcOrder: {},
                userIsShopFlag: null,
                showUpdateDiscount: false,
                allWorkAssignStateX: null,
                curDate: new Date()
            }
        },
        created: function () {
//            self.orderId = this.$route.query.id;
            this.allWorkAssignStateX = getEnumInfoWith("workAssignStateX", "name", "All").value;
            this.getServOrder();
            this.getCurrentUserInfo();

        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.selfPath, action, targetPostId);
            },
            getServOrder: function () {
                let self = this;
                let id = self.orderId;
                let loading = MsgBox.loading();
                servcOrderApi.getServcOrderInfo(id, function (result) {
                    if(result.type == "info") {
                        let servcOrder = result.data;
                        let itemList = servcOrder.itemList;
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            item.temporaryDiscount = item.discount;
                        }
                        self.servcOrder = servcOrder;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userIsShopFlag = result.data.scopeEntity.shopFlag;
                    }
                })
            },
            // 申请售后
            doSaleServc: function (orderId, orderItemId) {
                this.$router.push({
                    query: {orderId: orderId, orderItemId: orderItemId},
                    path: SwbAfterSaleOrderCreate.path
                });
            },
            // 代理下单
            agencyOrder: function (orderId, ssuId) {
                this.$router.push({
                    query: {orderId: orderId, ssuId: ssuId},
                    path: SwbServcOrderCreate.path
                });
            },
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            // 更改价格
            changeExtraDistCount(itemId){
                let servcOrder = this.servcOrder;
                let itemList = servcOrder.itemList || [];

                let item = itemList.find(function (row) {
                    return row["id"] == itemId
                });
                item.totalDiscount = item.toDoorFee + item.workFee + item.accFee + item.generallFee;
                if(!Utils.isNoB(item.discount)) {
                    item.deduction = item.discount;
                } else {
                    item.discount = 0;
                }
                if(item.discount > item.totalDiscount) {
                    MsgBox.warning("优惠价不可大于结算价")
                }
                if(Utils.isNaturalStr(item.discount) && item.discount <= item.totalDiscount) {
                    item.subtotal = parseFloat(item.totalDiscount) - parseFloat(item.discount);
                } else {
                    item.subtotal = item.totalDiscount;
                }
                item.amount = item.subtotal;

                let totalDiscount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    totalDiscount += parseFloat(item.discount);
                }
            },

            cancelPrice: function () {
                this.getServOrder();
                this.showUpdateDiscount = false;
            },

            saveChangePrice: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                let itemList = servcOrder.itemList;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    let totalDiscount = item.toDoorFee + item.workFee + item.accFee + item.generallFee;
                    if(item.discount > totalDiscount) {
                        MsgBox.warning(item.title + "优惠价不可大于结算价");
                        return;
                    }
                }
                let postData = {};
                postData.id = servcOrder.id;
                postData.totalDiscount = servcOrder.totalDiscount;
                postData.itemList = itemList;
                let loading = MsgBox.loading();
                servcOrderApi.modifyPrice(postData, function (result) {
                    if(result.type == "info") {
                        MsgBox.success("保存成功");
                        self.getServOrder();
                        self.showUpdateDiscount = false;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderDetails.vue